import React from "react";
import PropTypes from "prop-types";
import BottomDrawer from "@tw/shared-ui-components/lib/components/bottomDrawer/bottomDrawer";
import styles from "./variantDrawerMobile.scss";
import NewSpinner from "../newSpinner/newSpinner";
import FallbackImg from "../../assets/images/fallbackImg.png";

const VariantDrawerMobile = (props) => {
  const {
    open,
    setOpen,
    productInfo,
    renderVariants,
    renderFooter,
    renderAdditionalInfo,
    productStatus,
    isLoadingVariant,
    variantSelector,
  } = props;

  const intlNumberFormatter = new Intl.NumberFormat("en-US");
  return (
    <div className={styles["wrapper"]}>
      <BottomDrawer
        open={open}
        setOpen={setOpen}
        variantSelector={variantSelector}
      >
        {productInfo ? (
          <>
            <div className={styles["bottom_drawer"]}>
              {!isLoadingVariant && productInfo ? (
                <div className={styles["product_info_drawer"]}>
                  <div className={styles["product_img"]}>
                    {productInfo?.image ? (
                      <img
                        src={productInfo?.image}
                        alt={productInfo.productName}
                      />
                    ) : (
                      <img
                        style={{ objectFit: "contain", width: "70%" }}
                        src={FallbackImg}
                        alt=""
                      />
                    )}
                  </div>
                  <div className={styles["product_details"]}>
                    <div className={styles["product_brand"]}>
                      {productInfo.productBrand ? productInfo.productBrand : "-"}
                    </div>
                    <div className={styles["product_name"]}>
                      {productInfo.productName}
                    </div>
                  </div>
                  <div className={styles["product_prices"]}>
                    <div className={styles["product_price"]} translate="no">
                      {"$" +
                        " " +
                        intlNumberFormatter.format(Number(productInfo.price))}
                    </div>
                    {productStatus ? (
                      <span
                        className={styles["product_status"]}
                        style={{ color: productStatus?.colorCode }}
                      >
                        {productStatus?.label}
                      </span>
                    ) : null}
                  </div>
                </div>
              ) : (
                <div style={{ margin: "30px 0px", width: "100%" }}>
                  <NewSpinner />
                </div>
              )}
            </div>

            <div className={styles["mobile_variant"]}>{renderVariants()}</div>
            {productInfo && productInfo.isOutOfStock && (
              <div className={styles["out-of-stock-text"]}>暫停供貨</div>
            )}

            {renderAdditionalInfo && (
              <div className={styles["additional-info"]}>
                {renderAdditionalInfo}
              </div>
            )}

            {renderFooter && (
              <div className={styles["mobile_footer"]}>{renderFooter()}</div>
            )}
          </>
        ) : (
          <div style={{ margin: "100px 0px" }}>
            <NewSpinner />
          </div>
        )}
      </BottomDrawer>
    </div>
  );
};

VariantDrawerMobile.defaultProps = {
  open: false,
  setOpen: () => { },
  productInfo: null,
  renderVariants: () => { },
  renderFooter: () => { },
};

VariantDrawerMobile.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  productInfo: PropTypes.object,
  renderVariants: PropTypes.func,
  renderFooter: PropTypes.func,
};

export default VariantDrawerMobile;
